import theme from 'style/theme';
import styled from 'styled-components';

export const LightText = styled.span`
  font-weight: ${theme.fonts.weight.light};
`;
